const THEMES = ['theme-red', 'theme-green', 'theme-purple'];
const THEME_STORAGE_KEY = 'header-module-theme';

const previousTheme =
  localStorage.getItem(THEME_STORAGE_KEY) || THEMES.find((theme) => document.body.classList.contains(theme));

const availableThemes = previousTheme ? THEMES.filter((theme) => theme !== previousTheme) : THEMES;
const nextTheme = availableThemes[Math.floor(Math.random() * availableThemes.length)];

document.body.classList.remove(...THEMES);
document.body.classList.add(nextTheme);
localStorage.setItem(THEME_STORAGE_KEY, nextTheme);
